import PropTypes from 'prop-types';
import { cx, isNilOrEmptyString } from 'ramda-extension';

export const Section = ({ children, style, className }) => {
	return (
		<div className={cx('Section', { [className]: !isNilOrEmptyString(className) })} style={style}>
			{children}
		</div>
	);
};

Section.propTypes = {
	children: PropTypes.any,
	className: PropTypes.string,
	style: PropTypes.object,
};

export default Section;
